<template>
    <div>
        <header>
            <div class="header-container">
                <div>
                    <img v-if="this.$i18n.locale == 'en'" src="../assets/logo-en.svg" alt="Encounters With Canada" title="Encounters With Canada">
                    <img v-else src="../assets/logo-fr.svg" alt="Rencontres Du Canada" title="Rencontres Du Canada">
                </div>
                <div>
                    <TheLanguageSwitcher/>
                </div>
            </div>
        </header>
    </div>
</template>
<script>

import TheLanguageSwitcher from '@/components/TheLanguageSwitcher'

export default {
    name: 'TheHeader',
    components: {
        TheLanguageSwitcher,
    },
    methods: {
    },
    mounted: function (){
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue